module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av539-b963b0dd4f3150f52a6e5b874201fa17.jpg";